import { useContext } from 'react';

import { TranslateContext } from 'contexts/Translate/TranslateContext';

// Dictionary locale of the active page-translate session, or undefined when
// the page is not translated (status 'original' = currently translated).
// For notranslate UI — labels Google must never touch (date tokens, dynamic
// counters) — that still has to render localized while the page is
// translated: pass the result as the i18n-js per-call `{ locale }`. The app
// locale itself stays 'en' in a pure google-element session, so reading
// i18n.locale is not enough. Subscribing to the context also re-renders the
// consumer when the session starts/ends, flipping the labels together with
// the rest of the page.
const useTranslateSessionLocale = (): string | undefined => {
  const googleTranslate = useContext(TranslateContext);

  return googleTranslate && googleTranslate.status === 'original' ? googleTranslate.targetLanguage : undefined;
};

export default useTranslateSessionLocale;
